/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Unknown = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <g>
      <path
        d="M105.527,84.093c-8.028-3.103-9.6,1.006-9.6,1.006l-9.084,20.632c1.816,1.503,4.568,3.173,8.732,4.867
		c4.086,1.664,7.182,2.404,9.515,2.624l7.68-21.623C112.771,91.6,113.651,87.424,105.527,84.093z M109.027,96.959
		c-1.574,1.075-3.301,0.384-3.301,0.384l-8.31-3.406c0,0-2.275-1.109-2.156-2.232c0.12-1.123,0.521-2.929,2.079-5.521
		c1.035-1.349,3.059-0.65,3.059-0.65l9.614,3.942c0,0,1.538,0.676,1.422,2.064C111.318,92.931,110.713,95.41,109.027,96.959z"
      />
      <path
        d="M125.244,77.129c1.733-4.318-8.499-7.855-8.499-7.855l-0.229-1.194l-6.052-2.481l-1.041,0.822
		c-11.361-4.658-11.359-0.409-11.705,0.182L83.414,99.804c0,0-0.563,2.035,2.301,4.915l4.509-10.778l3.827-8.691
		c0,0,2.553-7.196,12.034-2.515c11.828,4.622,7.693,11.017,7.693,11.017l-7.265,19.547c4.25,0.026,5.312-1.869,5.312-1.869
		S123.513,81.447,125.244,77.129z M109.031,76.24l-2.331-0.954c-0.296-0.122-0.515-0.268-0.394-0.563
		c0.121-0.295,0.38-0.246,0.675-0.124l2.331,0.956c0.294,0.12,0.513,0.267,0.394,0.563C109.585,76.411,109.326,76.361,109.031,76.24
		z M112.721,77.753l-2.33-0.956c-0.297-0.12-0.515-0.267-0.395-0.562c0.122-0.295,0.379-0.246,0.675-0.125l2.332,0.955
		c0.293,0.121,0.513,0.268,0.392,0.563C113.274,77.923,113.015,77.874,112.721,77.753z"
      />
    </g>
    <path
      d="M34.676,81.816c-0.83-1.297-3.383-6.277-3.383-6.277s-3.186-8.988-6.935-11.082c-3.75-2.095-9.9-0.366-9.9-0.366
	s-5.694,0.981-7.463,3.862c-2.693,4.382-4.668,9.302-4.394,21.064c0.274,11.764,4.741,17.131,7.828,19.449
	c3.088,2.313,9.303,4.667,14.793,3.16c5.489-1.506,7.72-2.92,11.934-10.713C40.762,92.91,35.505,83.112,34.676,81.816z
	 M21.007,98.467c-3.651,0.87-7.316-1.381-8.188-5.031c-0.872-3.65,1.381-7.317,5.032-8.189c3.65-0.87,7.316,1.383,8.187,5.034
	C26.91,93.929,24.657,97.595,21.007,98.467z M18.312,65.555c8.296-2.479,8.326,5.838,8.326,5.838L18.312,65.555z"
    />
    <rect x="18.1" y="18.422" fill="none" width="90.003" height="89.999" />
    <g>
      <path
        d="M55.35,48.151H25.019c-2.247,0-3.878,1.492-3.878,3.546l0.133,7.137c0.711-0.91,1.814-1.499,3.056-1.499h27.309
		C52.353,54.064,53.615,50.964,55.35,48.151z"
      />
      <path
        d="M96.452,48.151h-7.066c-1.954,3.06-4.441,5.796-7.322,8.014c-0.531,0.408-1.073,0.799-1.626,1.17H97.19
		c1.175,0,2.226,0.526,2.937,1.352l0.126-6.963v-0.027C100.253,49.643,98.699,48.151,96.452,48.151z"
      />
    </g>
    <g>
      <path
        d="M50.082,78.628c-0.418-0.205-0.713-0.625-0.713-1.122c0-0.697,0.565-1.26,1.26-1.26c0.372,0,0.698,0.167,0.929,0.423
		c0.926-1.046,1.988-1.965,3.165-2.726c-1.723-0.815-3.034-2.353-3.541-4.224c-0.169,0.083-0.352,0.14-0.553,0.14
		c-0.695,0-1.26-0.565-1.26-1.261s0.565-1.26,1.26-1.26c0.113,0,0.214,0.036,0.318,0.064v-3.74c0-1.235,0.087-2.455,0.236-3.66
		H24.729c0.517,0,1.008,0.53,1.47,0.789c2.299,1.284,4.236,3.94,5.719,6.554c0.101-0.026,0.197-0.034,0.306-0.034
		c0.696,0,1.261,0.578,1.261,1.274c0,0.38-0.177,0.717-0.444,0.949c0.868,1.786,1.499,3.405,1.853,4.378
		c1.029,2.001,2.589,5.122,3.07,5.874C37.994,79.832,39.202,82,40.339,85h7.475C48.086,82.676,48.885,80.515,50.082,78.628z
		 M38.359,78.766c-0.696,0-1.26-0.564-1.26-1.26c0-0.697,0.564-1.26,1.26-1.26s1.261,0.564,1.261,1.26
		C39.62,78.202,39.055,78.766,38.359,78.766z M38.359,69.858c-0.696,0-1.26-0.565-1.26-1.261s0.564-1.26,1.26-1.26
		s1.261,0.564,1.261,1.26S39.055,69.858,38.359,69.858z M44.494,67.336c0.696,0,1.261,0.564,1.261,1.26s-0.565,1.261-1.261,1.261
		c-0.696,0-1.26-0.565-1.26-1.261S43.798,67.336,44.494,67.336z M44.494,78.766c-0.696,0-1.26-0.564-1.26-1.26
		c0-0.697,0.564-1.26,1.26-1.26c0.696,0,1.261,0.564,1.261,1.26C45.755,78.202,45.19,78.766,44.494,78.766z"
      />
      <path
        d="M97.19,60H76.48c-0.901,0.987-1.43,2.279-1.43,3.66v4.344c0,2.622-1.548,4.885-3.774,5.937
		c3.744,2.42,6.366,6.422,6.91,11.058h0.57c0.304-3,2.688-5.158,5.574-5.158c1.082,0,2.094,0.229,2.952,0.762l6.687-15.558
		c0.843-2.461,2.471-3.804,4.099-4.402C97.892,60.335,97.571,60,97.19,60z M90,69H76v-3h14V69z"
      />
    </g>
    <g>
      <path
        d="M46.802,91.445c0.587,0,1.156,0.077,1.703,0.208c-0.391-1.163-0.644-2.385-0.744-3.653h-6.43
		c0.44,1,0.785,3.258,0.927,5.118C43.503,92.116,45.083,91.445,46.802,91.445z"
      />
      <path
        d="M81.874,106.903l0.105-0.237c-1.169-1.376-1.847-2.674-2.227-3.813c-0.646-0.914-1.03-2.027-1.03-3.231
		c0-1.843,0.897-3.475,2.272-4.498l1.903-4.189C81.237,90.492,79.873,89,79.193,88h-0.954c-0.62,7.872-7.211,14.091-15.24,14.091
		c-3.346,0-6.435-1.092-8.956-2.922c-0.255,3.775-3.401,6.758-7.242,6.758c-2.544,0-4.784-1.326-6.082-3.31l-0.122,0.163
		c-2.1,3.884-3.895,6.22-5.818,8.22h51.447l-2.824-2.834L81.874,106.903z"
      />
    </g>
    <g>
      <path
        d="M86.294,21.516c-1.275-3.01-3.098-5.714-5.416-8.035c-2.32-2.319-5.023-4.142-8.035-5.416
		C69.722,6.746,66.409,6.076,63,6.076c-3.412,0-6.723,0.67-9.844,1.989c-3.012,1.274-5.715,3.096-8.035,5.416
		c-2.32,2.321-4.142,5.024-5.416,8.036c-1.32,3.121-1.989,6.433-1.989,9.844c0,0.313,0.255,0.569,0.57,0.569H49.25
		c0.315,0,0.569-0.256,0.569-0.569c0-7.267,5.913-13.18,13.18-13.18c7.266,0,13.18,5.913,13.18,13.18
		c0,4.124-1.879,7.935-5.152,10.454c-0.443,0.339-0.908,0.653-1.387,0.933c-0.055,0.032-0.111,0.064-0.166,0.096
		c-0.029,0.017-0.059,0.034-0.092,0.053l-0.002,0.001c-7.67,4.11-12.433,12.063-12.433,20.762v4.344c0,0.315,0.255,0.57,0.57,0.57
		h10.965c0.314,0,0.568-0.255,0.568-0.57V63.66c0-4.258,2.344-8.14,6.115-10.13c0.082-0.043,0.162-0.088,0.242-0.135l0.07-0.042
		c0.09-0.05,0.18-0.102,0.268-0.153c0.92-0.536,1.814-1.14,2.662-1.792c3-2.31,5.486-5.314,7.186-8.69
		c1.785-3.545,2.691-7.367,2.691-11.357C88.285,27.949,87.614,24.637,86.294,21.516z"
      />
      <path d="M63,77.49c-5.128,0-9.3,4.173-9.3,9.301s4.172,9.3,9.3,9.3c5.129,0,9.301-4.172,9.301-9.3S68.129,77.49,63,77.49z" />
    </g>
  </svg>
);
export default extendIcon(Unknown);
